import React from 'react';
import './IntegrationApplicationMasterData.css';

const StartPage: React.FC = () => {
  return (
    <div className="page">
      {/* Main Content Container */}
      <div className="master-data-container" style={{ marginTop: '0', padding: '0 10px' }}>
        <div className="md-card" style={{ padding: '20px' }}>
          <div className="md-card-content" style={{ padding: '0' }}>
            <div style={{ textAlign: 'center', maxWidth: '100%', margin: '0 auto' }}>
              <h1 style={{
                fontSize: '24px',
                fontWeight: '600',
                color: '#1976d2',
                marginBottom: '16px',
                lineHeight: '1.2',
                textAlign: 'center'
              }}>
                Welcome to the Application Portfolio Rationalization (APR) Platform
              </h1>

              <div style={{
                fontSize: '16px',
                lineHeight: '1.5',
                color: '#444',
                textAlign: 'center'
              }}>
                <p style={{ marginBottom: '20px', fontSize: '18px' }}>
                  Our APR Framework is designed to help enterprises simplify and modernize their IT landscape. While <strong>4R is our default disposition model</strong>, we also support other models such as the comprehensive <strong>7R framework</strong>.
                </p>

                {/* 4R Model Section */}
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '12px',
                  marginBottom: '24px',
                  border: '2px solid #1976d2'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    marginBottom: '16px'
                  }}>
                    <span style={{
                      background: '#1976d2',
                      color: 'white',
                      padding: '4px 12px',
                      borderRadius: '16px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>DEFAULT</span>
                    <h2 style={{ margin: 0, color: '#1976d2', fontSize: '20px', fontWeight: '600' }}>
                      4R Disposition Model
                    </h2>
                  </div>

                  {/* 4R Cards in a single row */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: '16px'
                  }}>
                    <div style={{
                      padding: '14px',
                      background: '#fff5f5',
                      borderRadius: '8px',
                      borderLeft: '4px solid #dc2626',
                      textAlign: 'center'
                    }}>
                      <h3 style={{ color: '#dc2626', marginBottom: '8px', fontSize: '16px' }}>
                        1. Retire
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                        Phase out applications that no longer deliver value.
                      </p>
                    </div>

                    <div style={{
                      padding: '14px',
                      background: '#fef3c7',
                      borderRadius: '8px',
                      borderLeft: '4px solid #f59e0b',
                      textAlign: 'center'
                    }}>
                      <h3 style={{ color: '#b45309', marginBottom: '8px', fontSize: '16px' }}>
                        2. Re-Platform
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                        Migrate applications to more cost-effective and scalable platforms.
                      </p>
                    </div>

                    <div style={{
                      padding: '14px',
                      background: '#f0f9ff',
                      borderRadius: '8px',
                      borderLeft: '4px solid #10b981',
                      textAlign: 'center'
                    }}>
                      <h3 style={{ color: '#059669', marginBottom: '8px', fontSize: '16px' }}>
                        3. Retain
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                        Keep and optimize applications that are strategic and high-performing.
                      </p>
                    </div>

                    <div style={{
                      padding: '14px',
                      background: '#e0e7ff',
                      borderRadius: '8px',
                      borderLeft: '4px solid #3b82f6',
                      textAlign: 'center'
                    }}>
                      <h3 style={{ color: '#1d4ed8', marginBottom: '8px', fontSize: '16px' }}>
                        4. Re-Design
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                        Transform applications to align with future business needs and innovation goals.
                      </p>
                    </div>
                  </div>
                </div>

                {/* 7R Model Section */}
                <div style={{
                  background: '#faf5ff',
                  padding: '20px',
                  borderRadius: '12px',
                  marginBottom: '28px',
                  border: '2px solid #7c3aed'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    marginBottom: '16px'
                  }}>
                    <span style={{
                      background: '#7c3aed',
                      color: 'white',
                      padding: '4px 12px',
                      borderRadius: '16px',
                      fontSize: '12px',
                      fontWeight: '600'
                    }}>ALTERNATIVE</span>
                    <h2 style={{ margin: 0, color: '#7c3aed', fontSize: '20px', fontWeight: '600' }}>
                      7R Disposition Model (Cloud Migration Framework)
                    </h2>
                  </div>

                  {/* 7R Cards - First row of 4 */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(4, 1fr)',
                    gap: '12px',
                    marginBottom: '12px'
                  }}>
                    <div style={{
                      padding: '12px',
                      background: '#fff',
                      borderRadius: '8px',
                      borderLeft: '4px solid #dc2626',
                      textAlign: 'center',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}>
                      <h3 style={{ color: '#dc2626', marginBottom: '6px', fontSize: '14px', fontWeight: '600' }}>
                        1. Retire
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '12px', lineHeight: '1.4' }}>
                        Eliminate applications that are no longer needed or duplicated across the portfolio.
                      </p>
                    </div>

                    <div style={{
                      padding: '12px',
                      background: '#fff',
                      borderRadius: '8px',
                      borderLeft: '4px solid #10b981',
                      textAlign: 'center',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}>
                      <h3 style={{ color: '#059669', marginBottom: '6px', fontSize: '14px', fontWeight: '600' }}>
                        2. Retain
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '12px', lineHeight: '1.4' }}>
                        Keep the application as-is for now (dependencies, low business value, or future strategy alignment).
                      </p>
                    </div>

                    <div style={{
                      padding: '12px',
                      background: '#fff',
                      borderRadius: '8px',
                      borderLeft: '4px solid #3b82f6',
                      textAlign: 'center',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}>
                      <h3 style={{ color: '#1d4ed8', marginBottom: '6px', fontSize: '14px', fontWeight: '600' }}>
                        3. Rehost
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '12px', lineHeight: '1.4' }}>
                        "Lift and Shift" - Move the application to the cloud without major changes. Infrastructure migration only.
                      </p>
                    </div>

                    <div style={{
                      padding: '12px',
                      background: '#fff',
                      borderRadius: '8px',
                      borderLeft: '4px solid #f59e0b',
                      textAlign: 'center',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}>
                      <h3 style={{ color: '#b45309', marginBottom: '6px', fontSize: '14px', fontWeight: '600' }}>
                        4. Re-Platform
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '12px', lineHeight: '1.4' }}>
                        "Lift-Tinker-Shift" - Make minimal optimizations (containerize, change DB engine) but keep core architecture.
                      </p>
                    </div>
                  </div>

                  {/* 7R Cards - Second row of 3 */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '12px'
                  }}>
                    <div style={{
                      padding: '12px',
                      background: '#fff',
                      borderRadius: '8px',
                      borderLeft: '4px solid #ec4899',
                      textAlign: 'center',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}>
                      <h3 style={{ color: '#be185d', marginBottom: '6px', fontSize: '14px', fontWeight: '600' }}>
                        5. Repurchase
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '12px', lineHeight: '1.4' }}>
                        "Drop and Shop" - Replace the existing application with a SaaS or COTS product instead of maintaining custom solution.
                      </p>
                    </div>

                    <div style={{
                      padding: '12px',
                      background: '#fff',
                      borderRadius: '8px',
                      borderLeft: '4px solid #7c3aed',
                      textAlign: 'center',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}>
                      <h3 style={{ color: '#6d28d9', marginBottom: '6px', fontSize: '14px', fontWeight: '600' }}>
                        6. Refactor / Re-Architect
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '12px', lineHeight: '1.4' }}>
                        Rewrite or restructure the application to modern architecture (microservices, event-driven, serverless).
                      </p>
                    </div>

                    <div style={{
                      padding: '12px',
                      background: '#fff',
                      borderRadius: '8px',
                      borderLeft: '4px solid #6b7280',
                      textAlign: 'center',
                      boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                    }}>
                      <h3 style={{ color: '#4b5563', marginBottom: '6px', fontSize: '14px', fontWeight: '600' }}>
                        7. Revisit / Re-License
                      </h3>
                      <p style={{ margin: 0, color: '#666', fontSize: '12px', lineHeight: '1.4' }}>
                        Reevaluate or temporarily defer modernization; maintain current licensing but plan future migration.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Key Benefits Section */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)',
                  gap: '16px',
                  marginBottom: '28px'
                }}>
                  <div style={{
                    padding: '16px',
                    background: '#fff',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '28px', marginBottom: '8px' }}>💰</div>
                    <h4 style={{ color: '#333', marginBottom: '6px', fontSize: '16px', fontWeight: '600' }}>
                      Cost Optimization
                    </h4>
                    <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                      Reduce IT spending by identifying redundant applications and consolidating your portfolio.
                    </p>
                  </div>

                  <div style={{
                    padding: '16px',
                    background: '#fff',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '28px', marginBottom: '8px' }}>📊</div>
                    <h4 style={{ color: '#333', marginBottom: '6px', fontSize: '16px', fontWeight: '600' }}>
                      Data-Driven Decisions
                    </h4>
                    <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                      Make informed decisions based on comprehensive scoring and assessment metrics.
                    </p>
                  </div>

                  <div style={{
                    padding: '16px',
                    background: '#fff',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '28px', marginBottom: '8px' }}>🚀</div>
                    <h4 style={{ color: '#333', marginBottom: '6px', fontSize: '16px', fontWeight: '600' }}>
                      Accelerated Transformation
                    </h4>
                    <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>
                      Streamline your modernization journey with clear roadmaps and actionable insights.
                    </p>
                  </div>
                </div>

                {/* Softura info section */}
                <div style={{
                  background: '#f8fafc',
                  padding: '24px',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  textAlign: 'left',
                  marginBottom: '28px'
                }}>
                  <p style={{ marginBottom: '14px', fontWeight: '500', color: '#1976d2', fontSize: '18px' }}>
                    We understand that application rationalization can seem complex and disruptive. That's why this platform was created: to make the journey structured, transparent, and seamless.
                  </p>

                  <p style={{ marginBottom: '12px', fontWeight: '600', color: '#333', fontSize: '18px' }}>
                    You can rely on us to:
                  </p>

                  <ul style={{
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    lineHeight: '1.7',
                    fontSize: '18px'
                  }}>
                    <li style={{ marginBottom: '8px', paddingLeft: '28px', position: 'relative' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#10b981' }}>✓</span>
                      Provide a guided, step-by-step process for evaluating and scoring applications.
                    </li>
                    <li style={{ marginBottom: '8px', paddingLeft: '28px', position: 'relative' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#10b981' }}>✓</span>
                      Ensure smooth execution with minimal disruption to your business operations.
                    </li>
                    <li style={{ marginBottom: '8px', paddingLeft: '28px', position: 'relative' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#10b981' }}>✓</span>
                      Offer expert support and advisory at every stage—whether defining your models, running assessments, or designing transformation roadmaps.
                    </li>
                    <li style={{ marginBottom: '0', paddingLeft: '28px', position: 'relative' }}>
                      <span style={{ position: 'absolute', left: '0', color: '#10b981' }}>✓</span>
                      Deliver comprehensive reporting and analytics to track progress and measure success.
                    </li>
                  </ul>
                </div>

                {/* Purple gradient section - positioned last */}
                <div style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  color: 'white',
                  padding: '24px',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}>
                  <p style={{
                    margin: 0,
                    fontSize: '18px',
                    fontWeight: '500',
                    lineHeight: '1.6'
                  }}>
                    With our expertise, you'll not only gain a clear, data-driven view of your application landscape, but also the confidence that every decision is backed by industry best practices and hands-on support.
                  </p>
                  <p style={{
                    margin: '14px 0 0 0',
                    fontSize: '18px',
                    fontWeight: '600'
                  }}>
                    Together, we'll unlock efficiency, reduce costs, and build a future-ready application portfolio.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StartPage;
